import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { PenTool, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const MarketingPanel = ({
  marketingType, setMarketingType, marketingTopic, setMarketingTopic,
  marketingResult, onGenerate, loading,
}) => (
  <div className="max-w-3xl mx-auto space-y-6" data-testid="marketing-panel">
    <Card className="card-tech p-8">
      <h2 className="text-2xl font-bold text-green-400 mb-2">
        <PenTool className="w-6 h-6 inline mr-2" /> Marketing Content Generator
      </h2>
      <p className="text-green-300 mb-6">Generate social posts, email campaigns, blog outlines, and ad copy.</p>
      <div className="space-y-4">
        <div>
          <label className="block text-green-400 text-sm font-semibold mb-2">Content Type</label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {['social', 'email', 'blog', 'ad'].map(type => (
              <Button key={type} onClick={() => setMarketingType(type)}
                className={`${marketingType === type ? 'btn-primary' : 'btn-secondary'} text-sm`}
                data-testid={`marketing-type-${type}`}>
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </Button>
            ))}
          </div>
        </div>
        <Textarea value={marketingTopic} onChange={e => setMarketingTopic(e.target.value)}
          placeholder="e.g., Launch of Millionaire Machine Pro tier with AI features"
          className="bg-black/50 border-green-500/30 text-green-300 min-h-20" rows={2} data-testid="marketing-topic-input" />
        <Button onClick={onGenerate} disabled={loading || !marketingTopic} className="btn-primary w-full py-4" data-testid="marketing-generate-button">
          {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Generating...</> : `Generate ${marketingType} Content`}
        </Button>
      </div>
      {marketingResult && (
        <div className="mt-6 p-4 bg-green-500/5 border border-green-500/20 rounded" data-testid="marketing-result">
          <h4 className="text-green-400 font-semibold mb-2">Generated Content:</h4>
          <div className="text-green-300 whitespace-pre-wrap leading-relaxed">{marketingResult}</div>
          <Button onClick={() => { navigator.clipboard.writeText(marketingResult); toast.success('Copied!'); }}
            className="btn-secondary mt-4" data-testid="copy-marketing-button">Copy to Clipboard</Button>
        </div>
      )}
    </Card>
  </div>
);
